import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeCountry'
})
export class RemoveCountryPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return value;

        const country = value.split(',');
        if (country.length === 1) return value;

        country.pop();
        return country.join(',').trim();
    }
}
